// extracted by css-extract-rspack-plugin
export default {"container":"ProcedureNew__container--EfqnV","cardSubText":"ProcedureNew__cardSubText--yDSbu"};